import React from 'react';
import PropTypes from 'prop-types';
import 'photoswipe/dist/photoswipe.css';
import { Gallery, Item } from 'react-photoswipe-gallery';
import { Row, Col } from 'components';
import { imageHolder } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var BorrowerDocuments = function BorrowerDocuments(_ref) {
  var _documents$front, _documents$front2, _documents$back, _documents$back2;

  var documents = _ref.documents;
  return ___EmotionJSX(Gallery, {
    withDownloadButton: true
  }, ___EmotionJSX(Row, {
    sm: 12,
    md: 6,
    horizontalGap: 16,
    verticalGap: 8
  }, ___EmotionJSX(Col, null, ___EmotionJSX(Item, {
    original: documents === null || documents === void 0 ? void 0 : (_documents$front = documents.front) === null || _documents$front === void 0 ? void 0 : _documents$front.image,
    thumbnail: documents === null || documents === void 0 ? void 0 : (_documents$front2 = documents.front) === null || _documents$front2 === void 0 ? void 0 : _documents$front2.image
  }, function (_ref2) {
    var _documents$front3;

    var ref = _ref2.ref,
        open = _ref2.open;
    return ___EmotionJSX("div", {
      ref: ref,
      role: "presentation",
      onClick: open,
      css: imageHolder(documents === null || documents === void 0 ? void 0 : (_documents$front3 = documents.front) === null || _documents$front3 === void 0 ? void 0 : _documents$front3.image)
    });
  })), ___EmotionJSX(Col, null, ___EmotionJSX(Item, {
    original: documents === null || documents === void 0 ? void 0 : (_documents$back = documents.back) === null || _documents$back === void 0 ? void 0 : _documents$back.image,
    thumbnail: documents === null || documents === void 0 ? void 0 : (_documents$back2 = documents.back) === null || _documents$back2 === void 0 ? void 0 : _documents$back2.image
  }, function (_ref3) {
    var _documents$back3;

    var ref = _ref3.ref,
        open = _ref3.open;
    return ___EmotionJSX("div", {
      ref: ref,
      role: "presentation",
      onClick: open,
      css: imageHolder(documents === null || documents === void 0 ? void 0 : (_documents$back3 = documents.back) === null || _documents$back3 === void 0 ? void 0 : _documents$back3.image)
    });
  }))));
};

BorrowerDocuments.propTypes = {
  documents: PropTypes.object
};
export default BorrowerDocuments;